import React, {PropTypes} from 'react';
import {reduxForm, Field} from 'redux-form';
import Submitting from 'shared/Submitting.jsx';
import StandardField from 'shared/StandardField.jsx';
import StandardCheckboxField from 'shared/StandardCheckboxField.jsx';

const DivisionItemForm = ({
  handleSubmit,
  pristine,
  submitting,
  onCancel,
  onSubmit,
  displayDefault,
  averageBased,
  ageBased,
  genderBased
}) => (
  <form
    className="animated fadeIn"
    onSubmit={handleSubmit(onSubmit)}
    noValidate
  >
    <div className="panel panel-primary">
      <div className="panel-body">
        <div className="flex justify-content direction-column">
          <h2 className="panel-body-sub-heading">{`General (Required)`}</h2>
          <Field
            autoFocus
            name="name"
            type="text"
            component={StandardField}
            placeholder="Division Name"
            tooltip="Use a descriptive name such as Division 1 (0-150)"
            tooltipPosition="top"
          />
          { displayDefault
            ? <div><div className="col-sm-4">
                <Field
                  name="isDefault"
                  component={StandardCheckboxField}
                  label="Set default"
                />
              </div></div>
            : null
          }
          { averageBased
            ? <div><div className="col-sm-4">
                <Field
                  name="minAverage"
                  type="number"
                  component={StandardField}
                  step="1"
                  min="0"
                  max="9900"
                  placeholder="Min. Average"
                />
              </div>
              <div className="col-sm-4">
                <Field
                  className="col-sm-6"
                  name="maxAverage"
                  type="number"
                  component={StandardField}
                  step="1"
                  min="0"
                  max="9900"
                  placeholder="Max Average"
                />
              </div></div>
            : null
          }
          {
            ageBased
            ? <div>
                <div className="col-sm-4">
                  <Field
                    name="minAge"
                    type="number"
                    component={StandardField}
                    step="1"
                    min="0"
                    max="999"
                    placeholder="Min Age Limit"
                  />
                </div>
                <div className="col-sm-4">
                  <Field
                    name="maxAge"
                    type="number"
                    component={StandardField}
                    step="1"
                    min="0"
                    max="110"
                    placeholder="Max Age Limit"
                  />
                </div>
              </div>
            : null
          }
          {
            genderBased
            ? <div><div className="col-sm-4">
                <Field
                  name="minFemale"
                  type="number"
                  component={StandardField}
                  step="1"
                  min="0"
                  max="99"
                  placeholder="Min Female"
                  label="Min Number Female"
                />
              </div>
              <div className="col-sm-4">
                <Field
                  name="minMale"
                  type="number"
                  component={StandardField}
                  step="1"
                  min="0"
                  max="99"
                  placeholder="Min Male"
                  label="Min Number Male"
                />
              </div></div>
            : null
          }
        </div>
        <hr />
        <div className="form-group text-right">
          <button
            type="button"
            className="btn btn-link"
            disabled={submitting}
            onClick={onCancel}
          >Cancel</button>
          {` `}
          <button
            type="submit"
            className="btn btn-primary btn-lg"
            disabled={pristine || submitting}
          >{submitting ? <Submitting /> : <i className="fa fa-floppy-o" />} {`Save`}</button>
        </div>
      </div>
    </div>
  </form>
);

DivisionItemForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  displayDefault: PropTypes.bool,
  averageBased: PropTypes.bool,
  ageBased: PropTypes.bool,
  genderBased: PropTypes.bool
};

export default reduxForm({
  form: 'divisionItemForm'
})(DivisionItemForm);



// WEBPACK FOOTER //
// ./src/features/tournament/divisions/DivisionItemForm.jsx